export default __webpack_public_path__ + "static/media/freqs.2ac6e695.PNG";